// libs
import * as React from 'react'

// components
import MessageSegment from 'src/components/message_segment/message_segment'
import Modal from 'src/components/modal/modal'

// interfaces / constants
import { ICTAModalContent } from 'src/components/cta/cta_intermediate_options'
import { CLASS_PREFIX } from 'src/constants/'

// helpers
import './message_segment.scss'
import { NO_PROFILE, PROFILE_STEP_PROFILE_COMPLETE } from '../../constants/user'

const cls: string = CLASS_PREFIX + 'cta'

export default class MessageSegmentWithModal extends React.PureComponent<ICTAModalContent, {}> {
  public render () {
    const { buttons, children, description, image, onClose, title, showAppStoreLinks, profileStatus } = this.props
    const showLargePopup = profileStatus === PROFILE_STEP_PROFILE_COMPLETE || profileStatus === NO_PROFILE

    return (
      <Modal onClose={onClose} showLarge={showLargePopup}>
        <div className={cls}>
          <MessageSegment
            headerIcon={image}
            title={title}
            message={description}
            buttons={buttons}
            profileStatus={profileStatus}
            showAppStoreLinks={showAppStoreLinks}
          />
          {children}
        </div>
      </Modal>
    )
  }
}
